import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Informacion from "@/pages/Informacion";
import PQR from "@/pages/PQR";
import Medidor from "@/pages/Medidor";
import Contacto from "@/pages/Contacto";
import Transparencia from "@/pages/Transparencia";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import { Loader2 } from "lucide-react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

const Public = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/informacion" element={<Public><Informacion /></Public>} />
          <Route path="/pqr" element={<Public><PQR /></Public>} />
          <Route path="/medidor" element={<Public><Medidor /></Public>} />
          <Route path="/contacto" element={<Public><Contacto /></Public>} />
          <Route path="/transparencia" element={<Public><Transparencia /></Public>} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
